import React from "react";
import { message, Form, Steps } from "antd";
import styled from "styled-components";
import { PlusOutlined } from "@ant-design/icons";
import { connect } from "react-redux";

import { getUserState } from "state/selector";
import colors from "constants/palette";
import Button from "components/buttons/Button";
import Fetch from "components/Fetch";
import { StyledModal } from "components/App/styled";
import Loading from "components/App/Loading";

import { CustomerStep, ProductList, Payment, Factor } from "./steps";

const { Step } = Steps;

function App({ visible, setVisible, buttonStyle, reload, oldData, user }) {
  const [form] = Form.useForm();

  const [current, setCurrent] = React.useState(0);
  const [productList, setProductList] = React.useState(
    oldData ? JSON.parse(oldData.data)?.list : []
  );
  const [paymentList, setPaymentList] = React.useState(
    oldData ? JSON.parse(oldData.data)?.payments : []
  );
  const [info, setInfo] = React.useState(false);
  const [customer, setCustomer] = React.useState(
    oldData ? oldData.customer : false
  );
  const [loading, setLoading] = React.useState(false);
  const [refresh, setRefresh] = React.useState(false);
  const [image, setImage] = React.useState(
    oldData?.data ? JSON.parse(oldData.data).images : []
  );
  const total = productList
    .map((item) => ({ amount: item.amount, price: item.price }))
    .reduce((a, b) => Number(a) + Number(b.amount) * Number(b.price), 0);
  const added = paymentList
    .map((item) => item.amount)
    .reduce((a, b) => Number(a) + Number(b), 0);

  const remain = total - added;

  React.useEffect(() => {
    Fetch.get("/orders/data", (res) => {
      setInfo(res);
      console.log("orders data", res);
      // oldData &&
      //   res.customers &&
      //   setCustomer(
      //     info.customers.findIndex((e) => e.name === oldData.customer)
      //   );
    });
  }, [oldData]);
  React.useEffect(() => {
    if (form.getFieldInstance()) {
      form.resetFields(["customer"]);
    }

    if (refresh) {
      setRefresh(false);
    }
  }, [form, refresh]);

  const showModal = () => {
    setVisible(true);
  };

  const onSubmit = (formData) => {
    if (!productList.length) {
      message.error("لطفا سفارش را وارد کنید");
      return false;
    }
    if (remain) {
      message.error("لطفا پرداختی ها را مشخص کنید");
      return false;
    }
    setLoading(true);
    const customerIndex = info.customers.findIndex((e) => e.name === customer);

    if (customerIndex < 0) {
      message.error("مشتری به درستی ثبت نشده است ");
      setLoading(false);
      return false;
    }
    var submitData = {
      customer: info.customers[customerIndex].name,
      shop: info.customers[customerIndex].shop,
      city: info.customers[customerIndex].city,
      phone: info.customers[customerIndex].phone,

      total: total,
      visitor: user.name,
      data: JSON.stringify({
        images: image,
        list: productList,
        payments: paymentList,
      }),
    };

    if (!oldData) {
      // new :::::::::::::
      Fetch.post("/orders", submitData, (res) => {
        console.log("manage order response", res);
        if (res?.id) {
          message.success("با موفقیت اضافه شد");
          cleanForm();
          setVisible(false);
          reload(true);
          setCurrent(0);
        } else {
          message.error("خطایی رخ داده است");
          if (res?.errors?.title) {
            message.error(res?.errors?.title[0]);
          }
        }
      });
    } else {
      // update :::::::::
      Fetch.put(`/orders/${oldData.id}`, submitData, (res) => {
        console.log("manage order response/ UPDATE", res);
        if (res?.ok) {
          message.success("با موفقیت آپدیت شد");
          cleanForm();
          setVisible(false);
          reload(true);
          setCurrent(0);
        } else {
          if (res?.errors?.title) {
            message.error(res?.errors.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    }
    setLoading(false);
  };
  console.log("customer ---------->", customer);
  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const cleanForm = () => {
    form.resetFields();
    setProductList([]);
    setPaymentList([]);
    setImage([]);
  };

  function newProductList(data) {
    setProductList(data);
    setRefresh(true);
  }
  function newPaymentList(data) {
    setPaymentList(data);
    setRefresh(true);
  }
  const next = () => {
    switch (current) {
      case 0:
        // check for customer
        console.log(customer);
        if (customer?.length) {
          setCurrent((e) => e + 1);
        } else {
          message.error("مشتری به درستی ثبت نشده است");
        }
        break;

      case 1:
        // check products in order
        if (productList.length > 0) {
          setCurrent((e) => e + 1);
        } else {
          message.error("لیست سفارش خالی است");
        }
        break;
      case 2:
        // check payments
        if (!remain) {
          setCurrent((e) => e + 1);
        } else {
          message.error("لطفا پرداختی ها را مشخص کنید");
        }
        break;
      case 3:
        // submit
        if (
          customer?.length &&
          productList.length > 0 &&
          paymentList.length > 0
        ) {
          form.submit();
        } else {
          message.error("خطایی رخ داده است");
        }
        break;
      default:
        break;
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  if (oldData) {
    form.setFieldsValue(oldData);
  }

  const steps = [
    {
      title: "انتخاب مشتری",
      content: (
        <CustomerStep
          info={info}
          setCustomer={setCustomer}
          customer={customer}
        />
      ),
    },
    {
      title: oldData ? "اصلاح" : "ثبت سفارش",
      content: (
        <ProductList
          products={info ? info.products?.reverse() : []}
          list={productList}
          setList={newProductList}
        />
      ),
    },
    {
      title: "ثبت پرداختی",
      content: (
        <Payment
          products={info.products}
          list={paymentList}
          setList={newPaymentList}
          productList={productList}
          productListLength={productList.length}
          remain={remain}
          orderId={oldData ? oldData.id : 0}
        />
      ),
    },
    {
      title: "تایید",
      content: (
        <Factor
          paymentList={paymentList}
          productList={productList}
          customer={customer}
        />
      ),
    },
  ];

  // if (!info?.products?.length) {
  //   return (
  //     <>
  //       <Button
  //         shape="round"
  //         color={colors.blue}
  //         onClick={showModal}
  //         style={buttonStyle && buttonStyle}
  //       >
  //         {oldData ? (
  //           "به روز رسانی"
  //         ) : (
  //           <span>
  //             <PlusOutlined style={{ marginLeft: 8 }} />
  //             سفارش جدید{" "}
  //           </span>
  //         )}
  //       </Button>
  //       <StyledModal visible={visible} onOk={onSubmit} onCancel={handleCancel}>
  //         کالایی اضافه نشده
  //         <br />
  //         ثبت سفارش امکان پذیر نیست
  //       </StyledModal>
  //     </>
  //   );
  // }
  // // loading
  // if (!info || productList.length < 0 || paymentList.length < 0) {
  //   return (
  //     <>
  //       <Button
  //         shape="round"
  //         color={colors.blue}
  //         onClick={showModal}
  //         style={buttonStyle && buttonStyle}
  //         footer={[
  //           <Button
  //             key="submit"
  //             type="primary"
  //             loading={loading}
  //             onClick={handleOk}
  //             style={{ width: "100%" }}
  //             color={colors.blue}
  //           >
  //             ثبت
  //           </Button>,
  //         ]}
  //       >
  //         {oldData ? (
  //           "به روز رسانی"
  //         ) : (
  //           <span>
  //             <PlusOutlined style={{ marginLeft: 8 }} />
  //             سفارش جدید
  //           </span>
  //         )}
  //       </Button>
  //       <StyledModal
  //         title={oldData ? "به روز رسانی" : " اضافه کردن سفارش"}
  //         visible={visible}
  //         onOk={onSubmit}
  //         onCancel={handleCancel}
  //         closable={false}
  //         footer={[
  //           <Button
  //             key="submit"
  //             type="primary"
  //             loading={loading}
  //             onClick={handleOk}
  //             style={{ width: "100%" }}
  //             color={colors.blue}
  //           >
  //             ثبت
  //           </Button>,
  //         ]}
  //         width={680}
  //       >
  //         <Loading />
  //       </StyledModal>
  //     </>
  //   );
  // }
  return (
    <>
      {/* <Button
        shape="round"
        color={colors.blue}
        onClick={showModal}
        style={buttonStyle && buttonStyle}
      >
        {oldData ? (
          "به روز رسانی"
        ) : (
          <span>
            <PlusOutlined style={{ marginLeft: 8 }} />
            سفارش جدید
          </span>
        )}
      </Button> */}
      <StyledModal
        title={oldData ? "به روز رسانی" : " سفارش جدید"}
        visible={visible}
        onOk={onSubmit}
        onCancel={handleCancel}
        closable={false}
        footer={[
          <div className="steps-action" key={0}>
            {current > 0 && (
              <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
                صفحه قبل
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button type="primary" onClick={() => next()} color={colors.blue}>
                صفحه بعد
              </Button>
            )}
            {current === steps.length - 1 && (
              <Button type="primary" onClick={onSubmit} color={colors.blue}>
                ثبت سفارش
              </Button>
            )}
          </div>,
        ]}
        width={680}
      >
        <Form
          form={form}
          layout="vertical"
          style={{ direction: "rtl" }}
          scrollToFirstError
          onFinish={onSubmit}
        >
          <Steps current={current}>
            {steps.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
          <ColContainer style={{ marginTop: 42 }}>
            {steps[current].content}
          </ColContainer>

          {/* <Col style={{ textAlign: "center" }}>
              <Upload maxAllowed={20} setImage={setImage} addedImages={image} />
            </Col> */}
        </Form>
      </StyledModal>
    </>
  );
}

const mapStateToProps = (state) => {
  const user = getUserState(state);
  return { user };
};
export default connect(mapStateToProps)(App);
const ColContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
